import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import ModalBase from "@material-ui/core/Modal";
import { ThemeContext } from "styled-components";
import { ThemeTypes } from "themes/colors";
import { toRgba } from "themes/helpers";

type ModalProps = {
  border?: string;
  boxShadow?: string;
  content: any;
  handleClose: () => void;
  height?: string;
  mobile?: boolean;
  open: boolean;
  padding?: string;
  width?: string;
};

interface StyleProps {
  border?: string;
  boxShadow?: string;
  height?: string;
  mobile?: boolean;
  padding?: string;
  theme: ThemeTypes;
  width?: string;
}

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    left: `${left}%`,
    outline: 0,
    top: `${top}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles({
  paper: (props: StyleProps) => {
    const { border, boxShadow, height, mobile, padding, theme, width } = props;
    return {
      backgroundColor: theme.colors.white,
      border: border ? border : mobile ? "" : `2px solid ${theme.colors.black}`,
      borderRadius: "4px",
      boxShadow: boxShadow
        ? boxShadow
        : mobile
        ? ""
        : `0px 16px 24px ${toRgba(theme.colors.black, 0.2)}`,
      height: mobile ? "100%" : height ? height : "80%",
      padding: padding || "0 55px 44px 55px",
      position: "absolute",
      width: mobile ? "100%" : width ? width : "33%",
    };
  },
});

const Modal = (props: ModalProps) => {
  const {
    border,
    boxShadow,
    content,
    handleClose,
    height,
    mobile,
    open,
    padding,
    width,
  } = props;

  const [modalStyle] = React.useState(getModalStyle);
  const theme = useContext(ThemeContext);

  const classes = useStyles({
    border,
    boxShadow,
    height,
    mobile,
    padding,
    theme,
    width,
  });

  return (
    <ModalBase
      aria-describedby="simple-modal-description"
      aria-labelledby="simple-modal-title"
      onClose={handleClose}
      open={open}
    >
      <div style={modalStyle} className={classes.paper}>
        {content}
      </div>
    </ModalBase>
  );
};

export default Modal;
